import {
  html,
  SYSBaseElement,
  unsafeHTML,
} from "../../../../../../_ovlclient/src"
import type { SYSTableDefIds } from "../../../../../../_ovlclient/src"
import { FileGet } from "../../../../../../_ovlclient/src/global/globalapi"
import { TableFormAddRow } from "../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../_ovlclient/src/textapi"
export class ScreenSymbolPCEndUser extends SYSBaseElement {
  accepted: boolean
  async getUI() {
    let filesDL
    if (this.accepted) {
      filesDL = html`<a
          @click=${async (e) => {
            e.preventDefault()
            e.stopPropagation()
            await FileGet({
              cat: "SPCSymbolPCInstaller",
            })
          }}
          href="#"
          class="fd-link fd-link--emphasized"
          tabindex="0"
          ><span class="fd-link__content"
            >${T("SPCSymbolPCUserDownloadInstallerTitle")}</span
          ></a
        >
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a
          @click=${async (e) => {
            e.preventDefault()
            e.stopPropagation()
            await FileGet({
              cat: "SPCSymbolPCEditor",
            })
          }}
          href="#"
          class="fd-link fd-link--emphasized"
          tabindex="0"
          ><span class="fd-link__content"
            >${T("SPCSymbolPCUserDownloadEditorTitle")}</span
          ></a
        >`
    }
    return html`
      <div
        class="ovl-smart-screen-margins-lr-large ovl-smart-padding-lr-symmetrical"
      >
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                <b>${T("SPCSymbolPCUserTitle")}</b>
              </h3>
            </div>
          </div>

          <div
            class="fd-layout-panel__body fd-has-padding-base fd-has-margin-base"
          >
            <a
              href="#"
              class="fd-link fd-link--emphasized"
              tabindex="0"
              @click=${async (e) => {
                e.preventDefault()
                e.stopPropagation()
                await FileGet({
                  cat: "SPCSymbolPCManualPDF",
                  desc: `kpik_manual_${this.state.ovl.session.Language.toLowerCase()}.pdf`,
                })
              }}
              ><span class="fd-link__content"
                >${T("SPCSymbolPCUserDownloadManualTitle")}</span
              ></a
            >

            ${unsafeHTML(T("SPCSymbolPCUserHintImportantBeforeDownload"))}

            <div class="fd-form-item">
              <input
                type="checkbox"
                class="fd-checkbox"
                id="Ai4ez611"
                ?checked=${this.accepted}
                @click=${(e) => {
                  if (!this.accepted) {
                    this.accepted = !this.accepted
                    this.doRender()
                  } else {
                    e.preventDefault()
                  }
                }}
              />
              <label class="fd-checkbox__label" for="Ai4ez611">
                <span class="fd-checkbox__checkmark" aria-hidden="true"></span>
                <div class="fd-checkbox__label-container">
                  <span class="fd-checkbox__text"
                    >${T("SPCSymbolPCUserUserAgrees")}</span
                  >
                </div>
              </label>
            </div>
            <br />
            ${filesDL}
            <br />
            <br />
            <ovl-table
              class="fd-table"
              .props=${() => <SYSTableDefIds>"SPCSymbolPCEndUser"}
            >
            </ovl-table>
          </div>
        </div>
      </div>
    `
  }
}

// Drucker hinzufügen Funktionalität für Enduser. Vorerst deaktiviert da Kalt AG im Prozess den Drucker schon hinzufügt
/*          <a
            @click=${async (e) => {
              e.preventDefault()
              await TableFormAddRow("SPCSymbolPCEndUser")
            }}
            href="#"
            class="fd-link fd-link--emphasized"
            tabindex="0"
            ><span class="fd-link__content"
              >${T("SPCSymbolPCUserAddPrinter")}</span
            ></a
          >
*/
